import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.05 3.951a4.47 4.47 0 0 0-6.32 0l-1.702 1.702a.687.687 0 1 0 .972.972l1.702-1.701a3.094 3.094 0 0 1 4.375 4.375l-2.43 2.43a3.097 3.097 0 0 1-4.376 0 .687.687 0 0 0-.972.973 4.474 4.474 0 0 0 6.32 0l2.43-2.43a4.47 4.47 0 0 0 0-6.32"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11 15.376 9.3 17.077a3.095 3.095 0 0 1-5.281-2.188 3.1 3.1 0 0 1 .906-2.187l2.43-2.43a3.097 3.097 0 0 1 4.376 0 .69.69 0 0 0 .75.149.69.69 0 0 0 .222-1.122 4.474 4.474 0 0 0-6.32 0l-2.43 2.43a4.469 4.469 0 0 0 6.32 6.32l1.7-1.701a.687.687 0 0 0-.972-.972"
    }, null, -1)
  ])))
}
export default { render: render }